import { render } from "./Lobby.vue?vue&type=template&id=2772da35&scoped=true&ts=true"
import script from "./Lobby.vue?vue&type=script&lang=ts"
export * from "./Lobby.vue?vue&type=script&lang=ts"

import "./Lobby.vue?vue&type=style&index=0&id=2772da35&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2772da35"]])

export default __exports__